// tODO: trigger dropdownonfocus
import sb from '@sb/util'

import AppendToBody from './append_to_body.js'

// items: { 'id': 'a', label: 'this is an item', group: 'a group', img: '', icon: '', desc}
// selected: id of the selected items
// mode: 'input', 'link', 'suggestion', 'custom'

// some account has > 1k fanpage => so you can display all in selection
const LIMIT_ITEM_DISPLAY = 50

export default {
	name: 'dropdown',
	props: [
		'items',
		'selected',
		'placeholder',
		'disabled',
		'img_style',
		'mode',
		'extra_cls',
		'extra_item_cls',
		'no_filter',
		'dropdown_width',
		'dropdown_height',
		'right',
		'toggle_always_open',
		'no_close_when_select',
		'no_open_when_items_empty',
		'no_arrow_down',
		'empty_content', // use to override when selected items is empty
		'input_value', // use with mode suggestion
	],

	data() {
		return {
			isDropdownOpen: false,
			filter: '',
			softSelected: '',
		}
	},

	watch: {
		items(items) {
			// DOnt use watch items because items always changed when parent call forceUpdated
			//if (lo.size(items) === 1) {
			//console.log('softSelected = 3', this.testProps)
			//this.softSelected = lo.get(items, '0.id')
			//} else {
			//console.log('softSelected = 4', this.testProps)
			////this.softSelected = ''
			//}
			//let $dropdown = this.$refs.dropdown_container
			//if (!$dropdown) return
			//$dropdown.scrollTop = 0
		},
		selected(selected) {
			this.softSelected = selected
		},
	},

	mounted() {
		document.body.addEventListener('keyup', this.onKeyup)
		document.body.addEventListener('keydown', this.onKeydown)

		this.$root.$on('closeDropdown2', this.closeDropdown)
		this.softSelected = this.selected
	},

	destroyed() {
		document.body.removeEventListener('keyup', this.onKeyup)
		document.body.removeEventListener('keydown', this.onKeydown)
		this.$root.$off('closeDropdown2', this.closeDropdown)
	},

	methods: {
		hasFilter() {
			if (this.no_filter) return false
			return lo.size(this.items) > 5
		},

		onKeydown(e) {
			if (!this.isDropdownOpen) return
			switch (e.keyCode) {
				case 38: {
					// UP
					let items = this.getFilteredItems()
					let idx = lo.findIndex(items, (item) => item.id === this.softSelected)
					idx--
					if (idx < 0) idx = lo.size(items) - 1
					this.softSelected = items[idx].id
					// this.$refs[`item${this.currentSelectedIndex}`].scrollIntoViewIfNeeded()

					// check to scroll
					let $dropdown = this.$refs.dropdown
					let $element = $dropdown.querySelector(`[data-id="${this.softSelected}"]`)
					$element.scrollIntoViewIfNeeded()
					e.preventDefault()
					break
				}
				case 40: {
					// DOWN
					let items = this.getFilteredItems()
					let idx = lo.findIndex(items, (item) => item.id === this.softSelected)
					idx++
					if (idx >= lo.size(items)) idx = 0
					this.softSelected = items[idx].id

					let $dropdown = this.$refs.dropdown
					let $element = $dropdown.querySelector(`[data-id="${this.softSelected}"]`)
					$element.scrollIntoViewIfNeeded()
					e.preventDefault()
					break
				}
			}
		},

		onKeyup(e) {
			if (!this.isDropdownOpen) return
			switch (e.keyCode) {
				case 27: // ESC
					if (this.filter) {
						this.filter = ''
						e.preventDefault()
						e.stopPropagation()
						break
					}

					this.closeDropdown()
					e.preventDefault()
					e.stopPropagation()
					break
				case 13: // ENTER
					var item = lo.find(this.items, (item) => item.id === this.softSelected)
					if (!item) return
					this.onSelectItem(item)
					break
			}
		},

		onMouseOver(item) {
			this.softSelected = item.id
		},

		ToogleDropdown(op) {
			setTimeout(() => this.toggleDropdown(op), 100) // so click event is bubbled
		},

		async toggleDropdown(op) {
			if (this.disabled) return
			if (op === true || op === false) this.isDropdownOpen = op
			else this.isDropdownOpen = !this.isDropdownOpen
			if (this.toggle_always_open) this.isDropdownOpen = true
			if (this.isDropdownOpen) {
				if (this.selected) {
					this.softSelected = this.selected
				} else {
					this.selectFirstItem()
				}
				this.$root.$emit('closeDropdown2')
				this.isDropdownOpen = true
			}
			this.filter = ''
			if (this.isDropdownOpen) {
				this.$emit('openDropdown')
				await this.$nextTick()
				let $filterInput = this.$refs.filter_input
				if ($filterInput) $filterInput.focus()
			}
		},

		selectFirstItem() {
			let items = this.getFilteredItems()
			if (lo.size(items)) {
				this.softSelected = lo.get(items, '0.id')
			}
		},

		getFilteredItems() {
			let items = lo.filter(this.items, (item) => {
				if (this.no_filter) return true
				if (this.mode === 'suggestion') return true
				let tag = lo.get(item, 'tag.title', '')
				tag = sb.unicodeToAscii(tag).toLowerCase()
				let text = item.label + ';' + (item.metadata || '') + ';' + (item.desc || '')
				let label = sb.unicodeToAscii(text).toLowerCase()
				let id = item.id || ''
				if (typeof id !== 'string') id = id + ''

				let filter = sb.unicodeToAscii(this.filter).toLowerCase()
				return label.indexOf(filter) > -1 || tag.indexOf(filter) > -1 || id.indexOf(filter) > -1
			})
			if (this.filter) {
				lo.each(items, (item) => {
					let filter = sb.unicodeToAscii(this.filter).toLowerCase()
					let label = sb.unicodeToAscii(item.label).toLowerCase()
					item._score = evalMatchStringScore(label, filter)
				})

				items = lo.orderBy(items, ['_score'], ['asc'])
			}
			return lo.take(items, LIMIT_ITEM_DISPLAY)
		},

		renderItems() {
			let items = this.getFilteredItems()
			if (!lo.size(items)) {
				if (this.empty_content) return <div>{this.empty_content}</div>
				return (
					<div class='w_100 h_100 d-flex align-items-center justify-content-center pl-4 pr-4 pt-4 pb-4'>
						<div class='text__muted text-center'>{this.$t('no_result')}</div>
					</div>
				)
			}

			// sort by group
			let groupM = {}
			lo.each(items, (item) => {
				let group = item.group ? item.group : ''
				groupM[group] = groupM[group] || []
				groupM[group].push(item)
			})

			let $items = []
			lo.map(groupM, (items, group) => {
				if (group) $items.push(<div class='dropdown__item dropdown__item_group'>{group}</div>)
				lo.map(items, (item) => {
					let cls = 'dropdown_item'
					if (this.softSelected === item.id) cls += ' active'
					if (this.extra_item_cls) cls += ` ${this.extra_item_cls}`
					if (item.checked) cls += ' checked'
					if (item.disabled) cls += ' dropdown_item__disabled'
					if (item.extra_cls) cls += ` ${item.extra_cls}`

					if (item.seperator && !item.id) {
						$items.push(<div class='dropdown_item__seperator' />)
					} else {
						$items.push(
							<div
								data-id={item.id}
								class={cls}
								vOn:click_stop={(_) => this.onSelectItem(item)}
								vOn:mouseover={(_) => this.onMouseOver(item)}
							>
								{this.renderItemContent(item)}
							</div>,
						)
					}
				})
			})
			return $items
		},

		renderItemContent(item) {
			if (item.tag) {
				return <Tag tag={item.tag} />
			}

			if (item.html && !item.label) {
				return item.html
			}

			if (item.extension && item.img && item.label) {
				let status = <div class='status_agent_dot call_online_dot'></div>
				let cls = 'dropdown_item_subtext'
				if (!item.status) {
					status = <div class='status_agent_dot call_unavailable_dot'></div>
					cls += ' item_unavailable'
				}

				return (
					<div class='d-flex align-items-center' style='height: 32px'>
						<img2 style={this.img_style} src={item.img} class='dropdown_item_img' />
						{status}
						<div class='text__truncate ml-3 dropdown_item_text' style='color: black; flex: 3'>
							{item.label}
						</div>
						<div class={cls} style='flex: 1'>
							{item.extension}
						</div>
					</div>
				)
			}

			if (item.img && item.desc) {
				return (
					<div class='d-flex align-items-center'>
						<img2
							src={item.img}
							class='dropdown_item_img'
							style={(this.img_style || '') + ';align-self: flex-start; top: 2px; position: relative'}
						/>
						<div class={{'ml-3': true, text__truncate: !item.no_truncate}} title={`${item.label}\&#10;${item.desc}`}>
							<div style='font-size: 14px' class='text__truncate dropdown_item_text'>
								{item.label}
							</div>
							<div
								style='font-size: 14px; line-height: 16px'
								class={{dropdown_item_subtext: true, text__truncate: !item.no_truncate}}
							>
								{item.desc}
							</div>
						</div>
					</div>
				)
			}
			if (item.img) {
				let cls = 'text__truncate ml-3 dropdown_item_text '
				let status = null
				if (item.status === true) {
					status = <div class='status_agent_dot call_online_dot'></div>
				}
				if (item.status === false) {
					status = <div class='status_agent_dot call_unavailable_dot'></div>
					cls += ' text__muted'
				}
				return (
					<div class='d-flex align-items-center'>
						<img2 style={this.img_style} src={item.img} class='dropdown_item_img' />
						{status}
						<div class={cls} title={item.label}>
							{item.label}
						</div>
					</div>
				)
			}
			if (item.icon && item.desc && item.no_truncate) {
				return (
					<div class='d-flex'>
						<div style='flex-shrink: 0'>{item.icon}</div>
						<div class='ml-3'>
							<div class='text__semibold dropdown_item_text'>{item.label}</div>
							<div style='font-size: 14px; white-space: pre-wrap' class='dropdown_item_subtext'>
								{item.desc}
							</div>
						</div>
					</div>
				)
			}
			if (item.icon) {
				return (
					<div class='d-flex align-items-center'>
						<div style='flex-shrink: 0'>{item.icon}</div>
						<div class='text__truncate ml-2 dropdown_item_text' title={item.label}>
							{item.label}
						</div>
						{item.tooltip && <Icon name='help' size='16' class='ml-2 text__muted' title={item.tooltip} />}
					</div>
				)
			}
			if (item.desc) {
				return (
					<div title={`${item.label}\u000A${item.desc}`} class={{text__truncate: !item.no_truncate}}>
						<div class='text__truncate dropdown_item_text'>{item.label}</div>
						<div
							style='font-size: 14px; line-height: 16px'
							class={{dropdown_item_subtext: true, text__truncate: !item.no_truncate}}
						>
							{item.desc}
						</div>
					</div>
				)
			}

			if (item.hasCheckbox) {
				return (
					<div class='d-flex align-items-center'>
						<input type='checkbox' class='form-check-input' checked={item.checked} />
						<div class='text__truncate dropdown_item_text ml-3' title={item.label}>
							{item.label}
						</div>
					</div>
				)
			}

			return (
				<div class='text__truncate dropdown_item_text' title={item.label}>
					{item.label}
				</div>
			)
		},

		onSelectItem(item) {
			this.$emit('select', item)
			if (!this.no_close_when_select) this.isDropdownOpen = false
		},

		focus() {
			if (this.mode === 'input') this.$refs.input.click()
			if (this.mode === 'suggestion') this.$refs.suggestion_input.focus()
		},

		clearFilterInput() {
			this.filter = ''
			this.$emit('input', '')
		},

		renderDropdown() {
			if (!this.isDropdownOpen) return null // avoid multi DOM append to body when a page have 10+ dropdown

			let $wrapper = this.$refs.container
			let rect = $wrapper ? $wrapper.getBoundingClientRect() : {}
			let {top = 0, left = 0, width = 0, height = 0, right = 0} = rect
			if (this.dropdown_width) width = this.dropdown_width

			let isBottom = document.body.offsetHeight - top < (this.dropdown_height || 400)
			let topStyle = `top: ${top + height + 2}px`
			let bottomStyle = `bottom: ${document.body.offsetHeight - top + 2}px; top: unset`

			let leftStyle = `left: ${left}px`
			let rightStyle = `left: unset; right: ${document.body.offsetWidth - right}px`
			let style = `position: fixed; z-index: 9999; ${isBottom ? bottomStyle : topStyle}; ${
				this.right ? rightStyle : leftStyle
			};`
			style += `min-width: ${width}px; max-width: ${width}px;`
			if (this.dropdown_height) {
				style += `max-height: ${this.dropdown_height}px`
			}
			if (!this.isDropdownOpen) style += 'display: none;'
			if (this.no_open_when_items_empty && !lo.size(this.items)) style += 'display: none;'

			return (
				<AppendToBody>
					<div vOn:click_stop={(_) => false} style={style} class='d-flex flex-column dropdown' ref='dropdown'>
						{this.hasFilter() && (
							<div class='dropdown_filter_container' vOn:click_stop={(_) => false}>
								<div class='dropdown_filter_input_container'>
									<Icon name='search' class='dropdown_filter_input_search_icon' size='13' />
									<input
										class='form-control dropdown_filter_input'
										placeholder={this.$t('search')}
										value={this.filter}
										ref='filter_input'
										vOn:input={this.onInput}
									/>
									{this.filter && (
										<Icon
											stroke-width='2'
											name='x'
											size='13'
											class='dropdown_filter_input_x_icon'
											vOn:click={this.clearFilterInput}
										/>
									)}
								</div>
							</div>
						)}
						{this.mode === 'suggestion' && !this.hasFilter() && (
							<div class='dropdown_filter_container'>
								<div class='d-flex align-items-center'>
									<div class='text__muted text__semibold' style='font-size: 14px'>
										{this.$t('suggestion')}
									</div>

									<icon name='x' size='18' class='x-icon ml-auto' vOn:click={() => this.closeDropdown()} />
								</div>
							</div>
						)}
						<div class='dropdown_item_cotainer' style={this.dropdown_height ? 'max-height: unset' : ''}>
							{this.renderItems()}
						</div>
					</div>
				</AppendToBody>
			)
		},

		onInput(e) {
			this.filter = e.target.value
			this.selectFirstItem()
			this.$emit('input', e.target.value)
		},

		renderInput() {
			let cls = 'dropdown_input '
			if (this.extra_cls) cls += ` ${this.extra_cls}`
			if (this.disabled) cls += ' disabled'

			let item = lo.find(this.items, (item) => item.id === this.selected)
			return (
				<div class={cls} ref='input' vOn:click={this.toggleDropdown}>
					{item ? (
						item.desc || item.hasCheckbox ? (
							<div class='text__truncate' title={item.label}>
								{item.label}
							</div>
						) : (
							this.renderItemContent(item)
						)
					) : (
						<div class='dropdown_input_placeholder text__truncate'>{this.placeholder || this.$t('select_an_item')}</div>
					)}
				</div>
			)
		},

		renderLink() {
			let cls = 'dropdown_link_selected'
			if (this.extra_cls) cls += ` ${this.extra_cls}`

			let item = lo.find(this.items, (item) => item.id === this.selected) || {}
			let text = item.selected_label || item.label || this.placeholder || this.$t('select_an_item')
			if (this.disabled) {
				return (
					<a href='javascript:;' class={cls} style='opacity: 0.7; pointer-events: none'>
						{text}
					</a>
				)
			}
			return (
				<div class={cls} vOn:click={this.toggleDropdown}>
					{text}{' '}
					{!this.no_arrow_down && (
						<Icon
							stroke-width='2'
							name='chevron-down'
							size='15'
							stroke='currentColor'
							class='ml-1'
							style='flex-shrink: 0'
						/>
					)}
				</div>
			)
		},

		onFocusSuggestionInput() {
			this.$root.$emit('closeDropdown2')
			this.isDropdownOpen = true
			this.$emit('focus')
		},

		onInputSuggestionInput(e) {
			this.$emit('input', e)
			this.isDropdownOpen = true
		},

		getDropdownIsOpenned() {
			if (this.no_open_when_items_empty && !lo.size(this.items)) return false
			return this.isDropdownOpen
		},

		renderSuggestionInput() {
			let cls = 'form-control'
			if (this.extra_cls) cls += ` ${this.extra_cls}`

			return (
				<input
					class={cls}
					vOn:input={this.onInputSuggestionInput}
					vOn:focus={this.onFocusSuggestionInput}
					vOn:click={this.onFocusSuggestionInput}
					value={this.input_value}
					ref='suggestion_input'
				/>
			)
		},

		closeDropdown() {
			this.isDropdownOpen = false
		},
	},

	render() {
		let $content = null
		let extra_cls = this.extra_cls || ''
		if (this.mode === 'input') $content = this.renderInput()
		else if (this.mode === 'link') $content = this.renderLink()
		else if (this.mode === 'suggestion') $content = this.renderSuggestionInput()
		else
			$content = (
				<div class={extra_cls} vOn:click={this.toggleDropdown}>
					{this.$slots.default}
				</div>
			)

		return (
			<div class='dropdown_container' ref='container' v-clickaway={this.closeDropdown}>
				{$content}
				{this.renderDropdown()}
			</div>
		)
	},
}

// string match fuction
function _min(d0, d1, d2, bx, ay) {
	return d0 < d1 || d2 < d1 ? (d0 > d2 ? d2 + 1 : d0 + 1) : bx === ay ? d1 : d1 + 1
}

function evalMatchStringScore(a, b) {
	if (a === b) {
		return 0
	}

	if (a.length > b.length) {
		var tmp = a
		a = b
		b = tmp
	}

	var la = a.length
	var lb = b.length

	while (la > 0 && a.charCodeAt(la - 1) === b.charCodeAt(lb - 1)) {
		la--
		lb--
	}

	var offset = 0

	while (offset < la && a.charCodeAt(offset) === b.charCodeAt(offset)) {
		offset++
	}

	la -= offset
	lb -= offset

	if (la === 0 || lb < 3) {
		return lb
	}

	var x = 0
	var y
	var d0
	var d1
	var d2
	var d3
	var dd
	var dy
	var ay
	var bx0
	var bx1
	var bx2
	var bx3

	var vector = []

	for (y = 0; y < la; y++) {
		vector.push(y + 1)
		vector.push(a.charCodeAt(offset + y))
	}

	var len = vector.length - 1

	for (; x < lb - 3; ) {
		bx0 = b.charCodeAt(offset + (d0 = x))
		bx1 = b.charCodeAt(offset + (d1 = x + 1))
		bx2 = b.charCodeAt(offset + (d2 = x + 2))
		bx3 = b.charCodeAt(offset + (d3 = x + 3))
		dd = x += 4
		for (y = 0; y < len; y += 2) {
			dy = vector[y]
			ay = vector[y + 1]
			d0 = _min(dy, d0, d1, bx0, ay)
			d1 = _min(d0, d1, d2, bx1, ay)
			d2 = _min(d1, d2, d3, bx2, ay)
			dd = _min(d2, d3, dd, bx3, ay)
			vector[y] = dd
			d3 = d2
			d2 = d1
			d1 = d0
			d0 = dy
		}
	}

	for (; x < lb; ) {
		bx0 = b.charCodeAt(offset + (d0 = x))
		dd = ++x
		for (y = 0; y < len; y += 2) {
			dy = vector[y]
			vector[y] = dd = _min(dy, d0, dd, bx0, vector[y + 1])
			d0 = dy
		}
	}

	return dd
}
